import { AbacaDatas } from "@/models/global.model";
import Vue from "vue";
import { http } from "./https.service";

export async function getGlobalData(): Promise<AbacaDatas> {
  const { data } = await http.get<AbacaDatas>(Vue.prototype.URL_JsonData);
  return data;
}
